import React from 'react'
import { motion } from "framer-motion"

import { transitionPages } from "./utils/animations"
import ComponentContainer from './utils/ComponentContainer';
import articles from "../data-articles.json";

const variantsList ={
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      },
      
    }
  }

  const item = {
    hidden: { opacity: 0, y: -50 },
    show: { opacity: 1, y: 0 },
    transition: { ease: "easeInOut" }
  };

const Home = () => {
    return (
        <ComponentContainer>
            <motion.main 
            initial={transitionPages.initial}
            exit={transitionPages.exit}
            animate={transitionPages.animate}
            transition={transitionPages.transition}
            className="home">
                <div>
                    <h1>Last News</h1>
                    <motion.ul
                        variants={variantsList}
                        initial="hidden"
                        animate="show"
                    >
                        {
                            articles.map((article, index) => (
                            <motion.li
                                variants={item}
                                key={index}
                            >
                                <article key={index} className="home__article">
                                    <div className="home__article__date">
                                        <span>{article.time} Minutes Read</span>
                                        <span>{article.date}</span>
                                    </div>
                                    <div className="home__article__offer">
                                        <h4>{article.title}</h4>
                                        <p>{`${article.body}`.slice(0, 120) + "..." }</p>
                                    </div>
                                    <button className="home__article__more btn btn-sm">Learn more</button>
                                </article>
                            </motion.li>
                                ))
                        }
                    </motion.ul>
                </div>
            </motion.main>
        </ComponentContainer>
    )
}

export default Home
